import type { TodoListConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";

export function validate(config: TodoListConfig): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
